import React from 'react'
import MainLayout from './MainLayout'
import About from '../components/About'

export default function AboutMe() {
    return (
        <>
            <MainLayout>
                <About/>
            </MainLayout>
        </>
    )
}
